export default "__VITE_ASSET__BowQwB$l__"